import React from "react";

const Button = ({className, type, text, progress, textVisible = false, ...otherProps}) => (
    <button
        className={className ? className : "btn btn-primary"}
        type={type ? type : "submit"}
        {...otherProps}
    >
        {
            progress ?
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"/>
                :
                null
        }
        {
            !textVisible ?
                text
                :
                null
        }
        {
            otherProps.children ? otherProps.children : null
        }
    </button>
);

export default Button;
